import { useEffect, useState } from "react"
import { MDBInput } from "mdb-react-ui-kit"
import styled from "@emotion/styled"

const StyledMDBInput = styled(MDBInput)`
  height: 28px;
  width: 100%;
  padding: 0 7px !important;
  margin: 5px 2px !important; 
`

export const DescripcionInput = ({ row, onCommit }: any) => {
  const [value, setValue] = useState(row.descripcion || "")

  // Si cambia la fila (paginación, reset, etc)
  useEffect(() => {
    setValue(row.descripcion || "")
  }, [row.descripcion])

  return (
    <StyledMDBInput
      value={value}
      name="descripcion"
      onChange={(e) => setValue(e.target.value)}
      onBlur={() => onCommit(value)}
    />
  )
}
